import { render, staticRenderFns } from "./BarcodeValidation.vue?vue&type=template&id=453071af&"
import script from "./BarcodeValidation.vue?vue&type=script&lang=js&"
export * from "./BarcodeValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/samenaankoop/src/vue-apps/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('453071af')) {
      api.createRecord('453071af', component.options)
    } else {
      api.reload('453071af', component.options)
    }
    module.hot.accept("./BarcodeValidation.vue?vue&type=template&id=453071af&", function () {
      api.rerender('453071af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "views/pages/BarcodeValidation.vue"
export default component.exports